import { cn } from '@/lib/cn';

/**
 * Logotipo da Prefeitura de Niterói.
 *
 * O arquivo (`/img/logo2.png`, 700×325) tem faixas brancas largas acima e abaixo da marca: a
 * proporção 700/136 com `object-cover` mostra só a área desenhada, sem cortar nem distorcer.
 * Assim a altura pedida (`h-8`, `h-12`) é a altura da marca, não a do arquivo.
 */
export function LogoNiteroi({ className }: { className?: string }) {
  return (
    <img
      src="/img/logo2.png"
      alt="Prefeitura de Niterói"
      width={700}
      height={136}
      className={cn('aspect-[700/136] h-8 w-auto shrink-0 object-cover', className)}
    />
  );
}
